<div class="component-container">
	<p class="title font-label-large">{{ title | translate }}</p>
	<div class="component-wrapper nice-scroll colored-scroll-track">
		<ng-container #componentOutlet></ng-container>
	</div>
	<div class="footer">
		<button mat-button [mat-dialog-close]="null">{{ 'cancel' | translate }}</button>
		<button
			#saveButton
			mat-flat-button
			class="tonal-flat-button"
			[disabled]="!selectedData.length"
			[mat-dialog-close]="selectedData"
		>
			{{ 'save' | translate }}
		</button>
	</div>
</div>
